import { render, staticRenderFns } from "./yhgProductShowList.vue?vue&type=template&id=6a275a32&"
import script from "./yhgProductShowList.vue?vue&type=script&lang=js&"
export * from "./yhgProductShowList.vue?vue&type=script&lang=js&"
import style0 from "./yhgProductShowList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports